<template>
  <div class="blog-card">
    <figure class="blog-card__image">
      <slot name="image" />
    </figure>
    <div class="blog-card__content">
      <p class="blog-card__date">
        <slot name="date" />
      </p>
      <p class="blog-card__title">
        <slot name="title" />
      </p>
      <div class="blog-card__text">
        <slot name="text" />
      </div>
      <div class="blog-card__tags">
        <slot name="tags" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogCard'
};
</script>

<style lang="scss" src="@/assets/components/blog/blog-card-view.scss"></style>
<style lang="scss" src="@/assets/components/loader/spinner.scss"></style>



// WEBPACK FOOTER //
// blog-card-view.vue